import styled from '@emotion/styled';
import { Button, colors, SearchBar, Tabs } from '@innovationdepartment/proxima-ui';
import type { BrandListProps, BrandTab } from 'types/brandList';
import HideCard from 'ui/HideCard';
import BrandListBrands from './BrandList.Brands';
import BrandListFavorites from './BrandList.Favorites';
import Filters from './Filters/Filters.Container';

const BrandListWrapper = styled.div`
  background-color: ${colors.neutral5};
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const TableWrapper = styled.div`
  position: relative;
  flex: 1;
  min-height: 400px;
  overflow: hidden;
`;

const SearchAndFilterWrapper = styled.div<{ show: boolean }>`
  display: ${({ show }) => (show ? 'inline-flex' : 'none')};
  border-radius: 8px;
  width: 100%;
  vertical-align: middle;
  align-items: center;
  gap: 16px;
`;

const SearchBarWrapper = styled.div`
  max-width: 600px;
  width: 600px;
  background-color: white;
`;

const BrandListTopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 48px;
`;

const BrandListView = <T,>(props: BrandListProps<T>) => {
  const {
    tabs,
    selectedTab,
    onTabChange,
    onFilterBrands,
    onFilterPlans,
    onFilterSpend,
    clearFilters,
    onCreateBrandClick,
    filterStateCounter,
    hasSelectedFilters,
    includeLockedBrands,
    onIncludeLockedBrands
  } = props;

  const isBrandsTab = selectedTab === 'all';
  const isFavoritesTab = selectedTab === 'favorites';

  return (
    <BrandListWrapper>
      <BrandListTopBar>
        <Tabs tabs={tabs} onChange={(key: string) => onTabChange(key as BrandTab)} />
        <Button label="Create brand" size="small" color="success" onClick={onCreateBrandClick} />
      </BrandListTopBar>
      <SearchAndFilterWrapper show={isBrandsTab}>
        <SearchBarWrapper data-testid="search-wrapper">
          <SearchBar onChange={onFilterBrands} />
        </SearchBarWrapper>
        <Filters
          key={`filters-state-${filterStateCounter}`}
          hasSelectedFilters={hasSelectedFilters}
          includeLockedBrands={includeLockedBrands}
          onIncludeLockedBrands={onIncludeLockedBrands}
          clearFilters={clearFilters}
          onFilterPlan={onFilterPlans}
          onFilterSpend={onFilterSpend}
        />
      </SearchAndFilterWrapper>
      <TableWrapper>
        <HideCard hide={!isBrandsTab} useContainerDimension>
          <BrandListBrands {...props} />
        </HideCard>
        <HideCard hide={!isFavoritesTab} useContainerDimension>
          <BrandListFavorites {...props} />
        </HideCard>
      </TableWrapper>
    </BrandListWrapper>
  );
};

export default BrandListView;
